import {
  Directive,
  ElementRef,
  Renderer2,
  Input,
  AfterViewInit,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appTruncate]',
})
export class TruncateDirective implements AfterViewInit {
  @Input('appTruncate') maxWidth: number | undefined;

  constructor(
    private readonly ele: ElementRef,
    private readonly renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    if (this.maxWidth) this.handleOverflown();
  }

  handleOverflown() {
    const originalText = this.ele.nativeElement.textContent;
    const tempEle = this.renderer.createElement('span');
    this.renderer.appendChild(document.body, tempEle);
    tempEle.textContent = originalText;
    const width = tempEle.getBoundingClientRect().width;
    if (this.maxWidth) {
      if (width > this.maxWidth) {
        let index = 1;
        do {
          tempEle.textContent = originalText.slice(0, index);
          index++;
        } while (
          tempEle.getBoundingClientRect().width <= this.maxWidth &&
          index <= originalText.length
        );
        this.ele.nativeElement.textContent =
          tempEle.textContent.slice(0, -3) + '...';
      }
      this.renderer.removeChild(document.body, tempEle);
    }
  }
}
